module.exports = {
  label: {
    headerTitle: 'Visitor Form',
    companyName: 'Company Name',
    groups: 'Groups',
    selectGroup: 'Select Group',
    siteName: 'Site Name',
    fromAccessDate: 'From Access Date',
    toAccessDate: 'To Access Date',
    selectDate: 'Select Date',
    departments: 'Department Visited',
    visitorRemarks: 'Visitor Remarks',
    questions: 'Questions',
    temperature: 'Body Temperature',
    workType: 'Work Type',
    buttons: {
      save: 'Save'
    },
    visitor:'Visitor'
  }
};
